"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _concatMiddleware = _interopRequireDefault(require("../concatMiddleware"));

var _createToastMiddleware = _interopRequireDefault(require("../../Toast/createToastMiddleware"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function createCoreMiddleware() {
  return (0, _concatMiddleware.default)(function () {
    return function (next) {
      return function (args) {
        var id = args.notification.id; // We are ignoring "connectivitystatus" notifications, we will render it using <BasicConnectivityStatus> instead.
        // If devs want to render it, they can add a middleware.

        return id !== 'connectivitystatus' && next(args);
      };
    };
  }, (0, _createToastMiddleware.default)());
}

var _default = createCoreMiddleware;
exports.default = _default;